import { render } from "./ValidationAcces.vue?vue&type=template&id=8dabd674&scoped=true"
import script from "./ValidationAcces.vue?vue&type=script&lang=js"
export * from "./ValidationAcces.vue?vue&type=script&lang=js"

import "./ValidationAcces.vue?vue&type=style&index=0&id=8dabd674&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8dabd674"]])

export default __exports__